<div class="chart-container">
  <ts-chart visualization="xy"
            (chartInitialized)="setUpChart($event)">
  </ts-chart>
</div>
